// ─────────────────────────────────────────────
//  RoomChainTrail — the provider's room chain for the shift (Phase 5.2).
//  Read-only horizontal chip trail: OR 1 → OR 2 → OR 3, derived by
//  domain/conditions.roomChainForProvider (persisted handoffs + live hop).
//  Not interactive — no tap targets, purely informational.
// ─────────────────────────────────────────────
import React from "react";
import tokens from "../theme/tokens";

const { color, font, radius } = tokens;

export default function RoomChainTrail({ steps = [], label = "Room chain today" }) {
  if (!steps || steps.length < 2) return null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }} aria-label={label}>
      <span style={{ fontSize: font.size.label, fontWeight: font.weight.bold, color: color.text.muted }}>
        🔗 {label}:
      </span>
      {steps.map((step, i) => (
        <React.Fragment key={`${step}-${i}`}>
          {i > 0 && (
            <span aria-hidden="true" style={{ color: color.accent.primary, fontWeight: font.weight.bold }}>
              →
            </span>
          )}
          <span
            style={{
              background: color.surface.raised,
              border: `1px solid ${color.border.default}`,
              color: color.text.secondary,
              borderRadius: radius.full,
              padding: "2px 10px",
              fontSize: font.size.label,
              fontWeight: font.weight.bold,
            }}
          >
            {step}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
